module.exports = __webpack_public_path__ + "media/react/fonts/fa-solid-900-5eef26d6096e6688a0f7b9e0ee960e1b.svg";